import { ApiResourceEmbed, ApiResourceLink } from '@/models';
import { AxiosRequestConfig, AxiosRequestHeaders } from 'axios';

export function makeAuthorizationHeader(headers: AxiosRequestHeaders, accessToken?: string): { Authorization: string } | undefined {
  // Do not override authorization header if the caller has previously set it
  if (!accessToken || !!headers.Authorization) {
    return;
  }

  headers.Authorization = `Bearer ${accessToken}`;
}

export function isApiResourceLink<T>(resource: ApiResourceEmbed<T>): resource is ApiResourceLink {
  return !!(resource as ApiResourceLink).href;
}
